module.exports = __webpack_public_path__ + "img/logout.3dcffb48.svg";